import { useEffect, useState } from 'react';
import './Home.css';
import { IFeed } from '../../interfaces/IFeed';
import Feed from '../feed/Feed';
import { PulseLoader } from 'react-spinners';

function Home() {
  const [feeds, setFeeds] = useState<IFeed[]>([]),
    [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    fetch('https://daily-trends-go.fly.dev/feeds/home')
      .then((response) => response.json())
      .then((feeds: IFeed[]) => {
        if (feeds) {
          setFeeds(feeds);
        }
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="Home">
      <h1>Daily Trends</h1>
      {!isLoading ? (
        feeds.length > 0 ? (
          <div className="Feeds">
            {feeds.map((feed) => (
              <Feed key={feed.id} content={feed} />
            ))}
          </div>
        ) : (
          <h3>No feeds today 📖📚</h3>
        )
      ) : (
        <>
          <PulseLoader
            loading={isLoading}
            cssOverride={{ margin: 'auto' }}
            size={30}
            color="rgb(253, 78, 78)"
          />
          <p>
            <i>Loading...</i>
          </p>
        </>
      )}
    </div>
  );
}

export default Home;
